@let ast = asset();
@switch (ast.type) {
  @case ('base64') {
    <app-asset-base64 [asset]="ast" [mode]="mode()" />
  }
  @case ('url') {
    <app-asset-url [asset]="ast" [mode]="mode()" />
  }
  @case ('visjs') {
    <app-asset-visjs [asset]="ast" [mode]="mode()" />
  }
  @case ('svg-source') {
    <app-asset-svg-source [asset]="ast" [mode]="mode()" />
  }
  @case ('svg-defs') {
    <app-asset-svg-defs [asset]="ast" [mode]="mode()" />
  }
  @case ('family-tree') {
    <app-asset-family-tree [asset]="ast" [mode]="mode()" />
  }
  @case ('cytoscape') {
    <app-asset-cytoscape [asset]="ast" [mode]="mode()" />
  }
  @case ('video') {
    <app-asset-video [asset]="ast" [mode]="mode()" (tryAgain)="tryAgain.emit($event)" />
  }
  @case ('person-events') {
    <app-asset-person-events [asset]="ast" [mode]="mode()" />
  }
  @default {
    <div class="d-flex align-items-center gap-1 text-muted">
      <i class="bi bi-file-earmark"></i>
      <span>Unknown asset type: {{ ast | json }}</span>
    </div>
  }
}
